import React from "react";

function Contact() {
  return (
    <div className="content">
      <p>In progress...</p>
    </div>
  );
}

export default Contact;
